<template>
  <div class="add-participants-list__wrapper">
  <ul  class="add-participants-list">
    <li
      @click="$emit('click', user)"
      class="add-participants-list__item"
      v-for="(user) of filteredUsers"
      :key="user.uid"
    >
      <b-form-checkbox
        v-if="enableSelect"
        :id="user.uid.toString()"
        class="add-participants-list__input"
        :checked="findUser(user)"
        @change="$emit('selectUser', user)"
        button-variant="outline-secondary"
      />
      <label class="add-participants-list__label" :for="user.uid">
        <add-participants-user-item
          @deleteUser="deleteSelectedUser"
          @changeMoney="changeMoney"
          :bordered="filteredUsers[filteredUsers.length-1].uid !== user.uid"
          :user="user"
          :show-money-input="showMoneyInput"
          :show-delete-button="showDeleteButton"
          :show-phone="showPhone"
          :disable-focus="false"
          :selected="findUser(user)"
          :show-money="showMoney"
          :money-amount="moneySum"
          :select-on-hover="selectOnHover"
        />
      </label>
    </li>
    <li
      v-if="(filteredUsers && !filteredUsers.length) && showEmptyEventPlaceholder"
      class="add-participants-list__item_no-item"
    >
      <div class="no-users-text">{{ $t('CP.allParticipantsAdded') }}</div>
    </li>
    <li
      v-else-if="(filteredUsers && !filteredUsers.length) && showEmptyPlaceholder"
      class="add-participants-list__item_no-item"
    >
      <img src="../../assets/img/sad.svg" alt="">
      <span class="no-users-text">{{ $t('CP.userNotFound') }}</span>
    </li>
  </ul>
  <intersection-observer @intersect="intersected"></intersection-observer>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { DELETE_EVENT_SELECTED_CONTACTS_REQUEST } from '@/store/user/types';
import AddParticipantsUserItem from '../AddParticipantsUserItem/AddParticipantsUserItem';
import IntersectionObserver from '../IntersectionObserver/IntersectionObserver';

export default {
  name: 'AddParticipantsList',
  components: {
    AddParticipantsUserItem,
    IntersectionObserver,
  },
  data() {
    return {
      usersMoney: [],
      page: 0,
    };
  },
  computed: {
    ...mapState({
      operation: (state) => {
        if (['even purchase', 'split purchase', 'i purchased them',
          'i lent them', 'they lent me', 'deposit', 'comment']
          .includes(state.operations.selectedOperation)) {
          return state.operations.selectedOperation;
        }
        return '';
      },
    }),
    filteredUsers() {
      try {
        return this.users.slice(0, (this.page + 1) * 10);
        // return this.users.filter((user) => !(user.full_name === this.$t('CP.me')
        //   && ['i purchased them', 'i lent them', 'they lent me']
        //     .includes(this.operation)));
      } catch (e) {
        return [];
      }
    },
  },
  methods: {
    intersected() {
      this.filteredUsers = this.users.slice(0, (this.page + 1) * 10);
      this.page += 1;
    },
    findUser(user) {
      const index = this.selected.findIndex((selectedUser) => selectedUser.uid === user.uid);
      return index !== -1;
    },
    deleteSelectedUser(user) {
      this.$store.dispatch(DELETE_EVENT_SELECTED_CONTACTS_REQUEST, user);
      const index = this.usersMoney.findIndex((userMoney) => user.phone === userMoney.phone);
      this.usersMoney.splice(index, 1);
      this.$emit('changeMoney', this.usersMoney);
    },
    changeMoney(userMoney) {
      const index = this.usersMoney
        .findIndex((user) => user.phone === userMoney.phone);
      if (index === -1) {
        this.usersMoney.push(userMoney);
      } else {
        this.usersMoney.splice(index, 1, userMoney);
      }
      this.$emit('changeMoney', this.usersMoney);
    },
  },
  props: {
    message: {
      type: String,
      default: 'dont show',
      validate: (val) => ['dont show', 'show money', 'show all'].includes(val),
    },
    users: {
      type: Array,
      default: () => [],
    },
    selected: {
      type: Array,
      default: () => [],
    },
    selectOnHover: {
      type: Boolean,
      default: false,
    },
    showDeleteButton: {
      type: Boolean,
      default: true,
    },
    disableFocus: {
      type: Boolean,
      default: false,
    },
    showMoneyInput: {
      type: Boolean,
      default: false,
    },
    moneySum: {
      type: Number,
      default: 0,
    },
    showMoney: {
      type: Boolean,
      default: false,
    },
    enableSelect: {
      type: Boolean,
      default: false,
    },
    showPhone: {
      type: Boolean,
      default: false,
    },
    showEmptyPlaceholder: {
      type: Boolean,
      default: true,
    },
    showEmptyEventPlaceholder: {
      type: Boolean,
      default: false,
    },
    isUserOwner: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
  .add-participants-list__wrapper {
    margin: 0 0 32px;
  }
  .add-participants-list {
    list-style-type: none;
    padding: 0 8px;
    overflow-y: auto;
    /*-ms-overflow-style: none;  !* IE and Edge *!*/
    /*scrollbar-width: none;  !* Firefox *!*/
    /*&::-webkit-scrollbar {*/
    /*  display: none; !* Chrome, Safari and Opera *!*/
    /*}*/
  }
  .add-participants-list__item {
    display: flex;
    align-items: center;
  }
  .add-participants-list__item_no-item {
    padding: 9px 0 0;
  }
  .add-participants-list__input {
    margin: 10px 0 0 26px;
    padding: 0;
  }
  .add-participants-list__label {
    display: block;
    flex: 1;
    margin: 0;
  }
  .no-users-text {
    font-size: 1rem;
    color: #ABB1CD;
    font-weight: normal;
    margin: 0 0 0 16px;
  }
</style>
